export default "__VITE_ASSET__CRYVUceL__"